import useTitle from "react-use/lib/useTitle";

import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { SubHeader } from "@/components/SubHeader";
import { Breadcrumb, Breadcrumbs } from "@/components/ui/breadcrumbs";
import { ViewProvider } from "@/features/view/components/ViewProvider";
import { NavStackProvider } from "@/utils/useNavStack";
import { HomeDashboard } from "../components";

export function Dashboard() {
  useTitle("Dashboard");

  return (
    <ViewProvider>
      <NavStackProvider label="Dashboard" href={{ to: "/" }}>
        <SubHeader>
          <SubHeader.Left>
            <Breadcrumbs>
              <Breadcrumb>Dashboard</Breadcrumb>
            </Breadcrumbs>
          </SubHeader.Left>
        </SubHeader>
        <HomeDashboard />
        <CommandMenuProvider>
          <CommandMenu />
        </CommandMenuProvider>
      </NavStackProvider>
    </ViewProvider>
  );
}
